// ** Icons
import BookOpenPageVariant from "mdi-material-ui/BookOpenPageVariant";
import AlertCircleOutline from "mdi-material-ui/AlertCircleOutline";

/******************************************************************
 * ##: FlixEmpty
 * Neutral empty state for the Flix catalog (learner has no courses).
 * @returns {JSX.Element} - the `.flix-state` panel
 * History:
 * 22-07-2026: Created
 ******************************************************************/
export const FlixEmpty = () => (
  <div className="flix-state">
    <span className="flix-state__icon">
      <BookOpenPageVariant />
    </span>
    <h3 className="flix-state__title">Ainda não tens cursos</h3>
    <p className="flix-state__text">Assim que um curso for adicionado à tua conta, aparece aqui pronto para começares a aprender.</p>
  </div>
);

/******************************************************************
 * ##: FlixError
 * Neutral error state for the Flix catalog when loading fails.
 * @returns {JSX.Element} - the `.flix-state` panel
 * History:
 * 22-07-2026: Created
 ******************************************************************/
export const FlixError = () => (
  <div className="flix-state flix-state--error">
    <span className="flix-state__icon">
      <AlertCircleOutline />
    </span>
    <h3 className="flix-state__title">Não foi possível carregar os cursos</h3>
    <p className="flix-state__text">
      Tenta novamente mais tarde. Se o erro continuar, contacta o suporte através de <strong>suporte@salespark.io</strong>.
    </p>
  </div>
);
